<script>
import axios from "axios";
import API from "@/services/API.js";
import Utils from "@/services/utils.js";
import Titlebar from "@/components/ui/Titlebar";
import UiCard from "@/components/ui/Card";
import Toolbar from "@/components/ui/Toolbar";
import MonitoringForm from "@/components/monitoring/Form.vue";
import UiSpinner from "@/components/ui/UiSpinner.vue";
import UiButton2 from "@/components/ui/Button2.vue";
import { required, minLength } from 'vuelidate/lib/validators'
import { hasMobile } from "@/components/monitoring/check-rules";
import {useDvFlagAccess} from "../../services/featureFlag";
const { formatLicenceId } = Utils

export default {
  name: "RemoteMonitoringForm",
  components: {
    Titlebar,
    MonitoringForm,
    UiSpinner,
    UiButton2,
    UiCard,
    Toolbar,
  },
  data() {
    return {
      routeId: this.$route.params?.id || null,
      viewState: 'INITIAL', // INITIAL, LOADING, ERROR, SUCCESS
      rmData: null,
      initialDatis: [],
    };
  },
  mounted() {
    if(!useDvFlagAccess('beepiz-remote-monitoring-can:create')){
      this.$router.push({ name: 'AccessDenied', params: { slug: "remotemonitoring_no_role"} })
    }
  },
  computed: {
    canEdit() {
      return useDvFlagAccess("beepiz-remote-monitoring-can:update");
    },
    rmDataForPost() {
      if (!this.rmData?.current) return null
      const { current } = this.rmData
      const formatedRmData = {
        name : current.name,
        datis: [...current?.datis],
        channels: current?.channels?.map((channel) => channel.id),
      }
      return formatedRmData
    },
    removedDatis() {
      return this.initialDatis.filter(({id}) => !this.rmData.current.datis.includes(id));
    },
    backPath() {
      return this.routeId
        ? { name: "RemoteMonitoringShow", params: { id: this.routeId } }
        : { name: "RemoteMonitoringList" };
    },
  },
  validations: {
    rmData: {
        current: {
          name: {
            required,
            minLength: minLength(1)
          },
          channels: {
            required,
            minLength: minLength(1),
            hasMobile
          },
        },
    },
  },
  methods: {
    formatLicenceId,
    initNewRm() {
      const DEFAULT_MONITORING_DATA = {
        current: {
          name: "",
          datis: [],
          channels: [],
        }
      };
      this.rmData = { ...DEFAULT_MONITORING_DATA };
      this.viewState = 'SUCCESS';
    },
    getRmData(id) {
      this.viewState = 'LOADING'
      axios
        .get(API.route(API.endpoints.remoteMonitoring.show, { procedureId: id }))
        .then(({data}) => {
          this.initialDatis = [...data.current.datis];
          const datisIds = data.current.datis.map((dati) => dati.id);
          const rmDataWithDatisFormated = {
            ...data,
            current: {
              ...data.current,
              datis: datisIds,
            },
          };
          this.rmData = rmDataWithDatisFormated;
          this.viewState = 'SUCCESS';
        })
        .catch((error) => {
          this.viewState = 'ERROR'
          this.i18nErrorMessage(`remoteMonitoring.back_end_messages.${error?.response?.data?.message}`)
        });
    },
    isSaveRmButtonDisabled() {
      if (this.viewState !== 'SUCCESS') return true
      if (this.rmData?.current?.status === 'waiting') return true
      if (!this.$v.rmData.current.name.$invalid && !this.rmData?.current?.datis?.length) return false
      if (this.$v.rmData.$invalid) return true
      return false
    },
    handleSaveRmButton() {
      if (this.routeId && !this.removedDatis.length) {
        this.updateMonitoring();
      } else if (this.routeId && !!this.removedDatis.length) {
        this.warnDatisRemovalBeforeUpdate();
      } else {
        this.createMonitoring();
      }
    },
    updateMonitoring() {
      this.viewState = 'LOADING'
      axios
        .put(API.route(API.endpoints.remoteMonitoring.update, { procedureId: this.routeId }), this.rmDataForPost)
        .then((response) => {
          if (response.status === 201) {
            this.goToPreviousPage(response.data.message.current.id)
          } else {
            this.viewState = 'SUCCESS'
            console.log(response)
          }
        })
        .catch((error) => {
          this.viewState = 'SUCCESS'
          this.i18nErrorMessage(`remoteMonitoring.back_end_messages.${error?.response?.data?.message}`)
        });
    },
    createMonitoring() {
      this.viewState = 'LOADING'
      axios
        .post(API.endpoints.remoteMonitoring.create, this.rmDataForPost)
        .then((response) => {
          if (response.status === 201) {
            this.goToPreviousPage(response.data.message.current.id)
          } else {
            this.viewState = 'SUCCESS'
            console.log(response)
          }
        })
        .catch((error) => {
          this.viewState = 'SUCCESS'
          this.i18nErrorMessage(`remoteMonitoring.back_end_messages.${error?.response?.data?.message}`)
        });
    },
    warnDatisRemovalBeforeUpdate() {
      window.Vfc.$refs.confirm.show({
        title: Utils.tc("remoteMonitoring.remove_dati_confirm.title", this.removedDatis.length),
        content: `
          <div class="text-left">
            <p>${Utils.tc("remoteMonitoring.remove_dati_confirm.content", this.removedDatis.length)}</p>
            <ul>
              ${this.removedDatis.map(({name, id}) => `
                <li>
                  <strong>${name}</strong>
                  <span class="text-mono text-muted ml-auto">${ formatLicenceId(id) }</span>
                </li>
              `).join('')}
            </ul>
          </div>
        `,
        callbackYes: () => {
          this.updateMonitoring();
        },
        yesButtonText: Utils.tc("global.save"),
        noButtonText: Utils.tc("global.cancel"),
      })
    },
    goToPreviousPage(id = null) {
      if (id === null) {
        this.$router.push({
          name: "RemoteMonitoringList",
        });
      } else {
        this.$router.push({
          name: "RemoteMonitoringShow",
          params: { id: id },
        });
      }
    },
    i18nErrorMessage(i18nErrorPath) {
      window.Vfc.$refs.messages.sendMessage(
        'error',
        this.$te(i18nErrorPath)
          ? this.$t(i18nErrorPath)
          : this.$t('errors.default')
      )
    },
  },
  created() {
    if (this.routeId) {
      this.getRmData(this.routeId);
    } else if (this.$route.path === this.$router.match({ name: "RemoteMonitoringNew" }).path) {
      this.initNewRm();
    } else {
      console.error("No remote Id provided", this.$route);
    }
    window.Vfc.$refs.loading.hide();
  },
};
</script>

<template>
  <div class="page-content pb-0">
    <Titlebar
      incrustation="fa-bullhorn"
      :isLoading="viewState === 'INITIAL' || viewState === 'LOADING'"
      :backPath="backPath"
    >
      <h1>{{ viewState === 'SUCCESS' && !!rmData.current ? rmData.current.name || $t("remoteMonitoring.procedures.titles.new") : $t("remoteMonitoring.titles.manager") }}</h1>
    </Titlebar>
    <UiCard>
      <div class="alert alert-info mb-4">{{ $t("remoteMonitoring.form.info") }}</div>
      <UiSpinner v-if="viewState === 'INITIAL' || viewState === 'LOADING'" />
      <section v-if="viewState === 'SUCCESS'">
        <MonitoringForm 
          v-if="rmData.current.status !== 'waiting' && canEdit"
          v-model="rmData.current" 
        />
        <p v-if="!canEdit">
          {{ $t('module.forbidden') }}
        </p>
      </section>
      <div class="d-flex align-items-center justify-content-end gap-3 mt-4">
        <UiButton2 
          v-can="'beepiz-browse-remotemonitoring'"
          @click.native.stop="goToPreviousPage()" 
          class="btn-lg"
        >
          {{ $t("global.cancel") }}
        </UiButton2>
        <UiButton2 
          v-can="'beepiz-edit-remotemonitoring'"
          @click.native.stop="handleSaveRmButton()" 
          class="btn-brand btn-lg"
          :disabled="isSaveRmButtonDisabled()"
        >
          {{ $t("global.save") }}
        </UiButton2>
      </div>
    </UiCard>
  </div>
</template>